import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { fetch_one, fetch_all } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';

import {
  Alert,
  Box,
  Button as Btn,
  Chip,
  CircularProgress,
  DialogActions,
  Divider,
  Grid,
  MenuItem,
  Tooltip,
} from '@mui/material';

import {
  Button,
  DatePicker,
  Dt,
  Editor,
  FileDrop,
  Select,
  TextInput,
  Typography
} from '../../../../components/v2/styled';

import { Advice } from '../../../../models/Advice';

const { DateTime } = require("luxon");

type Props = {
  onClick: (b:boolean) => void;
  open: boolean;
  setOpen: (b:boolean) => void;
  advice: Advice;
  clonedAdvice: Advice;
  setAdvice: (d:Advice) => void;
  loading?: boolean;
  activeCompare?: Advice;
  objects?: Advice[];
  weightTrigger?: boolean;
};

export const CoachEditAdviceTab2: FunctionComponent<Props> = ({objects, activeCompare, loading, open, setOpen, advice, clonedAdvice, setAdvice, onClick, weightTrigger}) => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const {t, i18n} = useTranslation(['translations']);

  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);
  const [lastWeight, setLastWeight] = useState<number>(0);
  const [firstWeight, setFirstWeight] = useState<number>(0);
  const [lastWaist, setLastWaist] = useState<number>(0);
  const [firstWaist, setFirstWaist] = useState<number>(0);

  useEffect(() => {
    [...(objects || [])].sort((a, b) => ((b.epi || 0) * 10000 + (b.idx || 0)) - ((a.epi || 0) * 10000 + (a.idx || 0))).forEach(obbb => {
      if (!!obbb.weight && (obbb.epi || 0) === (advice.epi || 0) && (obbb.idx || 0) < (advice.idx || 0)) setFirstWeight(parseFloat(obbb.weight));
      if (!!obbb.waist && (obbb.epi || 0) === (advice.epi || 0) && (obbb.idx || 0) < (advice.idx || 0)) setFirstWaist(parseFloat(obbb.waist));
    });
    [...(objects || [])].sort((a, b) => ((a.epi || 0) * 10000 + (a.idx || 0)) - ((b.epi || 0) * 10000 + (b.idx || 0))).forEach(obbb => {
      if (!!obbb.weight && (obbb.epi || 0) === (advice.epi || 0) && (obbb.idx || 0) < (advice.idx || 0)) setLastWeight(parseFloat(obbb.weight));
      if (!!obbb.waist && (obbb.epi || 0) === (advice.epi || 0) && (obbb.idx || 0) < (advice.idx || 0)) setLastWaist(parseFloat(obbb.waist));
    });
  }, [objects]);






  return (<>
    {!!weightTrigger && <Grid item xs={12}>
      <Alert severity='info'>
        <Typography>{t("coach.models.clients.is_weight_trigger")}</Typography>
      </Alert>
    </Grid>}
    {!!activeCompare && <Grid item xs={6}>
      <Typography variant="h4" sx={{textDecoration: 'underline'}}>{t("new_advices.detail.compare.title_current")}: {advice.identification} (<Dt o={advice.advice_date} />)</Typography>
    </Grid>}
    {!!activeCompare && <Grid item xs={6}>
      <Typography variant="h4" sx={{textDecoration: 'underline'}}>{t("new_advices.detail.compare.title_comparison")}: {activeCompare.identification} (<Dt d={activeCompare.advice_date} />)</Typography>
    </Grid>}
    <Grid item xs={3}>
      <TextInput
        id="height"
        disabled
        caption={t("client.models.advices.height", "Lengte (cm)")}
        helperText={t("client.models.advices.height_help", {url: `/user/${advice.user_id}/file?intake=1`})}
        helperHtml
        value={advice?.intake_profile_height || ""}
        onChange={(e) => {
          
        }}
      />
    </Grid>
    <Grid item xs={9}></Grid>
    <Grid item xs={!!activeCompare ? 3 : 4}>
      <TextInput
        id="weight"
        caption={t("client.models.advices.weight", "Gewicht (kg)")}
        placeholder={t("client.models.advices.placeholders.weight", "00.0")}
        value={advice?.weight || ""}
        outside_world
        onChange={(e) => {
          setAdvice({
            ...advice,
            weight: (e || '').replace(/,/g, '.')
          });
        }}
      />
    </Grid>
    <Grid item xs={!!activeCompare ? 3 : 4}>
      <TextInput
        id="waist"
        caption={t("client.models.advices.waist", "Middelomtrek (cm)")}
        placeholder={t("client.models.advices.placeholders.waist", "000")}
        value={advice?.waist || ""}
        onChange={(e) => {
          setAdvice({
            ...advice,
            waist: (e || '').replace(/[^0-9]/g, '')
          });
        }}
      />
    </Grid>
    {!activeCompare && <Grid item xs={4}>

    </Grid>}
    {!!activeCompare && <Grid item xs={3}>
      <TextInput
        id="weight"
        disabled
        caption={t("client.models.advices.weight", "Gewicht (kg)")}
        placeholder={t("client.models.advices.placeholders.weight", "00.0")}
        value={activeCompare?.weight || ""}
        onChange={(e) => {
          
        }}
      />
    </Grid>}
    {!!activeCompare && <Grid item xs={3}>
      <TextInput
        id="waist"
        disabled
        caption={t("client.models.advices.waist", "Middelomtrek (cm)")}
        placeholder={t("client.models.advices.placeholders.waist", "000")}
        value={activeCompare?.waist || ""}
        onChange={(e) => {
          
        }}
      />
    </Grid>}

    <Grid item xs={!!activeCompare ? 3 : 4}>
      {!!lastWeight && <>
        <Divider sx={{marginTop: 1, marginBottom: 1}} />
        <Typography variant="caption">{t("new_advices.detail.measures.last_weight")}</Typography>
        <Typography variant="body1">{lastWeight}kg</Typography>
        {parseFloat((advice.weight || '0').replace(",", ".")) > 0 && <Typography variant="caption">{t("new_advices.detail.measures.last_weight_difference")}</Typography>}
        {/* {parseFloat((advice.weight || '0').replace(",", ".")) > 0 && <Typography variant="body1">{(parseFloat((advice.weight || '0').replace(",", ".")) - lastWeight).toFixed(1)}kg</Typography>} */}
        <Chip sx={{marginLeft: 0.5}} label={`${(parseFloat((advice.weight || '0').replace(",", ".")) - lastWeight).toFixed(0)}kg`} />
      </>}
      {!!firstWeight && <>
        <Divider sx={{marginTop: 1, marginBottom: 1}} />
        <Typography variant="caption">{t("new_advices.detail.measures.first_weight_episode")}</Typography>
        <Typography variant="body1">{firstWeight}kg</Typography>
        {parseFloat((advice.weight || '0').replace(",", ".")) > 0 && <Typography variant="caption">{t("new_advices.detail.measures.first_weight_episode_difference")}</Typography>}
        {/* {parseFloat((advice.weight || '0').replace(",", ".")) > 0 && <Typography variant="body1">{(parseFloat((advice.weight || '0').replace(",", ".")) - firstWeight).toFixed(1)}kg</Typography>} */}
        <Chip sx={{marginLeft: 0.5}} label={`${(parseFloat((advice.weight || '0').replace(",", ".")) - firstWeight).toFixed(0)}kg`} />
      </>}
    </Grid>
    <Grid item xs={!!activeCompare ? 3 : 4}>
      {!!lastWaist && <>
        <Divider sx={{marginTop: 1, marginBottom: 1}} />
        <Typography variant="caption">{t("new_advices.detail.measures.last_waist")}</Typography>
        <Typography variant="body1">{lastWaist}cm</Typography>
        {parseFloat((advice.waist || '0').toString().replace(",", ".")) > 0 && <Typography variant="caption">{t("new_advices.detail.measures.last_waist_difference")}</Typography>}
        {/* {parseFloat((advice.waist || '0').toString().replace(",", ".")) > 0 && <Typography variant="body1">{(parseFloat((advice.waist || '0').toString().replace(",", ".")) - lastWaist).toFixed(0)}cm</Typography>} */}
        <Chip sx={{marginLeft: 0.5}} label={`${(parseFloat((advice.waist || '0').toString().replace(",", ".")) - lastWaist).toFixed(0)}cm`} />
      </>}
      {!!firstWaist && <>
        <Divider sx={{marginTop: 1, marginBottom: 1}} />
        <Typography variant="caption">{t("new_advices.detail.measures.first_waist_episode")}</Typography>
        <Typography variant="body1">{firstWaist}cm</Typography>
        {parseFloat((advice.waist || '0').toString().replace(",", ".")) > 0 && <Typography variant="caption">{t("new_advices.detail.measures.first_waist_episode_difference")}</Typography>}
        {/* {parseFloat((advice.waist || '0').toString().replace(",", ".")) > 0 && <Typography variant="body1">{(parseFloat((advice.waist || '0').toString().replace(",", ".")) - firstWaist).toFixed(0)}cm</Typography>} */}
        <Chip sx={{marginLeft: 0.5}} label={`${(parseFloat((advice.waist || '0').toString().replace(",", ".")) - firstWaist).toFixed(0)}cm`} />
      </>}
    </Grid>
    {!!activeCompare && <Grid item xs={3}></Grid>}
    {!!activeCompare && <Grid item xs={3}></Grid>}

    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={12}></Grid>
  </>);
}
